<template lang='pug'>
v-dialog(
	:model-value='show'
	@update:model-value='!$event ? emit("clicked", "cancel") : null'
	:persistent="persistent"
	:max-width="dialogMaxWidth"
	:min-width="dialogMinWidth"
	width="auto"
	eager
	location="top"
	scrim="true"
	)
	.tw-white-card.tw-flex.tw-flex-col.tw-items-center.tw-justify-center.tw-gap-2
		v-progress-linear(
			v-show="loginDialog.loadingForm"
			indeterminate
			class="tw-mt-[-18px] tw-ml-5"
			style="width: calc(100% + 20px)"
			)
		v-form.tw-w-full(
			@submit.prevent
			fast-fail
			ref="loginForm"
			validate-on="submit"
			)

			h4.tw-mb-5.tw-text-2xl Login Trenitalia

			div.tw-flex.tw-flex-col.tw-gap-2
				v-text-field(
					:label="$t('form_labels.name', 'Nome') + '*'"
					v-model="formData.name"
					:rules="requiredRules"
					:error-messages="formErrors.name"
				)
				v-text-field(
					:label="$t('form_labels.surname', 'Cognome') + '*'"
					v-model="formData.surname"
					:rules="requiredRules"
					:error-messages="formErrors.surname"
				)
				v-text-field(
					label="(CartaFreccia, X-GO, Carta ...)*"
					v-model="formData.cartafreccia"
					:rules="cartaRules"
					:error-messages="formErrors.cartafreccia"
				)

		.tw-flex.tw-justify-between.tw-w-full
			v-btn(@click="emit('clicked', 'cancel')" flat) {{$t('common.cancel', 'Annulla')}}
			v-btn(@click='login' color="primary-darken-1" :loading="loginDialog.loadingForm" type="submit") {{$t('dialogs.login.login', 'Accedi')}}
</template>
	
<script setup>
import {useLoginDialogStore} from "@/stores/use-login-dialog";
import {computed, inject, onMounted, ref} from "vue";
import {useI18n} from "vue-i18n";
import {useDisplay} from "vuetify";
import {getOnlyNumbers, rules_checkRequiredFields} from "@/common-scripts/utilities";


const i18n = useI18n();
const emit = defineEmits(['clicked']);
const props = defineProps({
	show: {
		type: Boolean,
		default: true
	},
	persistent: {
		type: Boolean,
		default: true
	},
	loading: {
		type: Boolean,
		default: false
	},
});
const loginForm = ref(null);
const loginDialog = useLoginDialogStore();
const formData = loginDialog.formData;
const formErrors = loginDialog.formErrors;
const cartaRules = [
	v => rules_checkRequiredFields(v, i18n),
	v => {
		formData.cartafreccia = getOnlyNumbers(v);
		return true;
	}
];
const requiredRules = [
	v => rules_checkRequiredFields(v, i18n),
];
const isMobile = inject('isMobile');
const dialogMinWidth = computed(() => {
	return isMobile ? '90%' : '40%';
});
const dialogMaxWidth = computed(() => {
	return isMobile ? '100%' : '50%';
});


async function login() {
	try {
		const validation = await loginForm.value.validate();
		if (validation.valid) {
			emit('clicked', 'login');
		}
	} catch (e) {
		console.error('error login in component', e);
		return false;
	}
}


</script>